(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-bigimg"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.startTransparent = this.hasAttribute('data-start-transparent');

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      if (this.startTransparent) {
        this.header.classList.add('section-header--transparent');
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop === 0) this.classList.add('header-wrapper--transparent');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.remove('header-wrapper--transparent');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.remove('header-wrapper--transparent');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.startTransparent) this.classList.add('header-wrapper--transparent');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

class NestedHeader extends HTMLElement {
  constructor() {
    super();
    this.headerSection = document.querySelector('.section-header');
    this.header = this.querySelector('.header');
    this.hamburgerButton = this.querySelector('button.header--mobile__hamburger');
    this.mainLinks = this.querySelectorAll('button.header__link--main');
    this.dropdown = this.querySelector('.header__dropdown');
    this.childMenus = this.querySelectorAll('.header__dropdown__menu--child');
    this.childLinks = this.querySelectorAll('.header__dropdown__menu--child .header__dropdown__link');
    this.grandchildMenus = this.querySelectorAll('.header__dropdown__menu--grandchild');
    this.featuredLinks = this.querySelectorAll('.header__dropdown__featured-link');
    this.mobileMenu = this.querySelector('.header__menu--mobile');

    if (this.hamburgerButton) this.hamburgerButton.addEventListener('click', () => { this.toggleDropdown(); });

    for (const mainLink of this.mainLinks) {
      mainLink.addEventListener('mouseover', (e) => {
        if (!this.dropdown) return;
        if (e.target.style.textDecoration !== 'underline') {
          this.resetStyles();
          const linkTitle = e.target.dataset.linkTitle;

          for (const link of this.mainLinks) {
            if (link.dataset.linkTitle === linkTitle) link.style.textDecoration = 'underline';
            else link.style.textDecoration = '';
          }

          this.showChildMenus(linkTitle, this.childMenus);
          this.headerSection.classList.add('section-header--active');
          this.openDropdown();
        }
      });
    }

    for (const childLink of this.childLinks) {
      childLink.addEventListener('mouseover', (e) => {
        for (const link of this.childLinks) link.style.textDecoration = '';
        childLink.style.textDecoration = 'underline';
        this.showChildMenus(e.target.dataset.linkTitle, this.grandchildMenus);
      });
    }

    this.setMobileMenuMaxHeight();
    window.addEventListener('resize', this.setMobileMenuMaxHeight);
  }

  showChildMenus(parentLinkTitle, childMenus) {
    for (const childMenu of childMenus) {
      if (childMenu.dataset.parentLinkTitle === parentLinkTitle) childMenu.style.display = '';
      else childMenu.style.display = 'none';
    }
    
    const key = (parentLinkTitle || '').trim().toUpperCase();
    
    console.log('HOVER KEY:', key);

     // ✅ Only swap hero when we're showing MAIN -> CHILD menus
     // // (prevents child hover from overriding hero) 
    if (childMenus === this.childMenus) {
    this.showHeroVariant(key);
  }

  for (const featuredLink of this.featuredLinks) {
    if (featuredLink.dataset.navmenuTrigger && featuredLink.dataset.navmenuTrigger.toUpperCase() === key) {
      featuredLink.removeAttribute('hidden');
    } else {
      featuredLink.setAttribute('hidden', '');
      }
    }
  }

showHeroVariant(triggerKey) {
  const heroes = this.querySelectorAll('.header__dropdown__hero--variant');
  if (!heroes || heroes.length === 0) return;

  const norm = (s) =>
    (s || '')
      .replace(/\u00A0/g, ' ') // convert non-breaking spaces to regular spaces
      .replace(/\s+/g, ' ')   // collapse multiple spaces/newlines
      .trim()
      .toUpperCase();

  const key = norm(triggerKey);

  let matched = false;

  heroes.forEach(hero => {
    const heroKey = norm(hero.dataset.heroTrigger);
    const shouldShow = heroKey === key;

    if (shouldShow) {
      hero.removeAttribute('hidden');
      matched = true;
    } else {
      hero.setAttribute('hidden', '');
    }
  });

  // fallback: DEFAULT if present, otherwise first hero
  if (!matched) {
    const fallback = [...heroes].find(h => norm(h.dataset.heroTrigger) === 'DEFAULT') || heroes[0];
    if (fallback) fallback.removeAttribute('hidden');
  }
}



  resetStyles() {
    for (const mainLink of this.mainLinks) mainLink.style.textDecoration = '';
    for (const childLink of this.childLinks) childLink.style.textDecoration = '';
    for (const childMenu of this.childMenus) childMenu.style.display = 'none';
    for (const grandchildMenu of this.grandchildMenus) grandchildMenu.style.display = 'none';
    for (const featuredLink of this.featuredLinks) featuredLink.setAttribute('hidden', '');
    this.headerSection.classList.remove('section-header--active');

    // optional: hide hero variants on reset
    const heroes = this.querySelectorAll('.header__dropdown__hero--variant');
    heroes.forEach(hero => hero.setAttribute('hidden', ''));
  }

  get clickOffHandler() {
    const fn = (e) => { if (!e.target.closest('nested-header')) this.closeDropdown(); };
    Object.defineProperty(this, 'clickOffHandler', { value: fn });
    return fn;
  }

  openDropdown() {
    if (this.dropdown) {
      document.body.classList.add('overflow-hidden-tablet');
      document.addEventListener('mouseover', this.clickOffHandler);
      this.dropdown.style.display = '';
    }
  }

  closeDropdown() {
    if (this.dropdown) {
      this.dropdown.style.display = 'none';
      document.body.classList.remove('overflow-hidden-tablet');
      document.removeEventListener('mouseover', this.clickOffHandler);
      this.resetStyles();
    }
  }

  toggleDropdown() {
    if (this.dropdown.style.display) this.openDropdown();
    else this.closeDropdown();
  }

  setMobileMenuMaxHeight() {
    requestAnimationFrame(() => {
      if (!this.header?.getBoundingClientRect) return;
      const offset = this.header.getBoundingClientRect().bottom;
      this.mobileMenu.style.maxHeight = `calc(100vh - ${offset}px)`;
    });
  }
}
customElements.define('nested-header', NestedHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.startTransparent = this.hasAttribute('data-start-transparent');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      if (this.startTransparent) {
        this.header.classList.add('section-header--transparent');
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop === 0) {
          this.classList.add('header-wrapper--transparent');
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.remove('header-wrapper--transparent');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.remove('header-wrapper--transparent');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.startTransparent) this.classList.add('header-wrapper--transparent');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  class NestedHeader extends HTMLElement {
    constructor() {
      super();
      this.headerSection = document.querySelector('.section-header');
      this.header = this.querySelector('.header');
      this.hamburgerButton = this.querySelector('button.header--mobile__hamburger');
      this.mainLinks = this.querySelectorAll('button.header__link--main');
      this.dropdown = this.querySelector('.header__dropdown');
      this.childMenus = this.querySelectorAll('.header__dropdown__menu--child');
      this.childLinks = this.querySelectorAll('.header__dropdown__menu--child .header__dropdown__link');
      this.grandchildMenus = this.querySelectorAll('.header__dropdown__menu--grandchild');
      this.featuredLinks = this.querySelectorAll('.header__dropdown__featured-link');
      this.mobileMenu = this.querySelector('.header__menu--mobile');      

      if (this.hamburgerButton) {
        this.hamburgerButton.addEventListener('click', () => {
          this.toggleDropdown();
        });
      }

      for (const mainLink of this.mainLinks) {
        mainLink.addEventListener('mouseover', (e) => {
          if (!this.dropdown) return;

          if (e.target.style.textDecoration !== 'underline') {
            this.resetStyles();

            const linkTitle = e.target.dataset.linkTitle;
            for (const link of this.mainLinks) {
              if (link.dataset.linkTitle === linkTitle)
                link.style.textDecoration = 'underline';
              else
                link.style.textDecoration = '';
            }
            this.showChildMenus(linkTitle, this.childMenus);
            this.headerSection.classList.add('section-header--active');
            this.openDropdown();
          }
        });
      }

      for (const childLink of this.childLinks) {
        childLink.addEventListener('mouseover', (e) => {
          for (const link of this.childLinks) {
            link.style.textDecoration = '';
          }
          childLink.style.textDecoration = 'underline';
          this.showChildMenus(e.target.dataset.linkTitle, this.grandchildMenus);
        });
      }

      this.setMobileMenuMaxHeight();
      window.addEventListener('resize', this.setMobileMenuMaxHeight);
    }

    showChildMenus(parentLinkTitle, childMenus) {
      for (const childMenu of childMenus) {
        if (childMenu.dataset.parentLinkTitle === parentLinkTitle) {
          childMenu.style.display = '';
        } else {
          childMenu.style.display = 'none';
        }
      }

      const key = parentLinkTitle.toUpperCase();
      for (const featuredLink of this.featuredLinks) {
        if (featuredLink.dataset.navmenuTrigger?.toUpperCase() === key) {
          featuredLink.removeAttribute('hidden');          
        } else {
          featuredLink.setAttribute('hidden', '');
        }        
      }
    }

    resetStyles() {
      for (const mainLink of this.mainLinks) {
        mainLink.style.textDecoration = '';
      }
      for (const childLink of this.childLinks) {
        childLink.style.textDecoration = '';
      }
      for (const childMenu of this.childMenus) {
        childMenu.style.display = 'none';
      }
      for (const grandchildMenu of this.grandchildMenus) {
        grandchildMenu.style.display = 'none';
      }
      for (const featuredLink of this.featuredLinks) {
        featuredLink.setAttribute('hidden', '');
      }
      this.headerSection.classList.remove('section-header--active');
    }

    get clickOffHandler() {
      const fn = (e) => {
        if (!e.target.closest('nested-header')) {
          this.closeDropdown();
        }
      }
      Object.defineProperty(this, 'clickOffHandler', { value: fn });
      return fn;
    }

    openDropdown() {
      if (this.dropdown) {        
        document.body.classList.add('overflow-hidden-tablet');
        document.addEventListener('mouseover', this.clickOffHandler);
        this.dropdown.style.display = '';
      }
    }

    closeDropdown() {
      if (this.dropdown) {
        this.dropdown.style.display = 'none';
        document.body.classList.remove('overflow-hidden-tablet');
        document.removeEventListener('mouseover', this.clickOffHandler);
        this.resetStyles();
      }
    }

    toggleDropdown() {
      if (this.dropdown.style.display) {
        this.openDropdown();
      } else {
        this.closeDropdown();
      }
    }

    setMobileMenuMaxHeight() {
      requestAnimationFrame(() => {
        if (!this.header?.getBoundingClientRect) {
          return;
        }

        const offset = this.header.getBoundingClientRect().bottom;
        this.mobileMenu.style.maxHeight = `calc(100vh - ${offset}px)`;
      });
    }
  }
  customElements.define('nested-header', NestedHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-about"]) return;
  try {
    
  class SyncedCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.imageCarousel = this.querySelector('.embla__image-carousel');
      this.textCarousel = this.querySelector('.embla__text-carousel');
      this.dotsContainer = this.querySelector('.embla__dots');
      this.dots = [];

      this.imageCarouselApi = EmblaCarousel(
        this.imageCarousel,
        { loop: false, watchDrag: false }
      );

      this.textCarouselApi = EmblaCarousel(this.textCarousel, { loop: false });
      this.textCarouselApi
        .on('init', this.addDots.bind(this))
        .on('reInit', this.addDots.bind(this))
        .on('init', this.toggleDotsActive.bind(this))
        .on('reInit', this.toggleDotsActive.bind(this))
        .on('select', this.handleSelect.bind(this))
        .on('destroy', this.removeDots.bind(this));
    }

    addDots() {
      this.dotsContainer.innerHTML = this.textCarouselApi
        .scrollSnapList()
        .map(() => '<button class="embla__dot" type="button"> </button>')
        .join('');

      const scrollTo = (index) => {
        this.imageCarouselApi.scrollTo(index);
        this.textCarouselApi.scrollTo(index);
      };

      this.dots = Array.from(this.dotsContainer.querySelectorAll('.embla__dot'));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => scrollTo(index), false);
      });
    }

    toggleDotsActive() {
      const previous = this.textCarouselApi.previousScrollSnap();
      const selected = this.textCarouselApi.selectedScrollSnap();
      this.dots[previous].classList.remove('embla__dot--selected');
      this.dots[selected].classList.add('embla__dot--selected');
    }

    handleSelect() {
      const selected = this.textCarouselApi.selectedScrollSnap();
      this.imageCarouselApi.scrollTo(selected);

      this.toggleDotsActive();
    }

    removeDots() {
      this.dotsContainer.innerHTML = '';
      this.dots = [];
    }
  }

  customElements.define('synced-carousel', SyncedCarousel);

  } catch(e) { console.error(e); }
})();
})();
